import { useTranslation } from "react-i18next";
import { Outlet, useLocation } from 'react-router-dom'

import { AuthGuard } from '../../components/authentication/auth-guard'
import { Layout, Menu } from "antd";
import Header from "../header/Header";
import {useViewport} from '../../hooks/useViewport';
import {useState} from 'react';
import LoadingFullScreen from "../../components/loading-full-screen/LoadingFullScreen";

export default function DashboardRootPageNoMenu() {
const location = useLocation()
  const pạthname = location.pathname
  const { width } = useViewport();
  const isMobile = width <= 768;
  const [loading, setLoading] = useState(false);

  return (
    <AuthGuard>
      <main>
        <Layout>
          <Header activeMenu={() => { }} />
          {/* {isMobile && (
            <Menu
              mode="horizontal"
              defaultSelectedKeys={[location.pathname]}
              items={menuItems}
              className="menu-mobile"
            />
          )} */}
          <Layout>
            {/* <Sidebar /> */}
            {loading && <LoadingFullScreen spinning={loading} />}
            <Outlet />
          </Layout>
        </Layout>
      </main>
    </AuthGuard>
  )
}
